import React from 'react';
import className from 'classnames';
import moment from 'moment';

import {
  canEdit
} from '../../lib/policies';

import TableHeader from '../TableHeader';
import EditParameterModal from './EditParameterModal'

const PostScoreParametersList = ({
  postScoreParameters = [],
  total = 0,
}) => {

  return (
    <React.Fragment>
      <div className='MainHeader'>
        <div className='MainHeader__left'>
          <h2 className='MainHeader__h2'>Post Score Parameters</h2>
          <p className='MainHeader__left__p'>Total {total.toLocaleString()} parameters</p>
        </div>
      </div>
      <div
        className={className('Table', {
          'Table--trust-parameters': true,
        })} style={{gridTemplateColumns: '1fr 1fr 1fr 1fr 1fr 0.5fr'}}
      >
        {(() => {
        const columnHeaders = [
          {
            label: 'Key'
          },
          {
            label: 'Equation'
          },
          {
            label: 'Parameter Type'
          },
          {
            label: 'Create At'
          },
          {
            label: 'Update At'
          },
          {
            label: 'Manage',
          }
        ]

        return (
          <div className='Table__row'>
            {columnHeaders.map((header, key) => (
              <TableHeader
                key={key}
                header={header}
              />
            ))}
          </div>
          )
        })()}
        {postScoreParameters.map((postScoreParameter) => (
          <div
            className='Table__row'
            key={postScoreParameter.id}
          >
            <div className='Table__col'>{postScoreParameter.key}</div>
            <div className="Table__col">{postScoreParameter.equation}</div>
            <div className='Table__col'>{postScoreParameter.parameterType}</div>
            <div
              className='Table__col'
              dangerouslySetInnerHTML={
                {
                  __html: postScoreParameter.createdAt !== null ?
                    moment(postScoreParameter.createdAt).format('YYYY-MM-DD HH:mm')
                  :
                    'N/A'
                }
              }
            />
            <div
              className='Table__col'
              dangerouslySetInnerHTML={
                {
                  __html: postScoreParameter.updatedAt !== null ?
                    moment(postScoreParameter.updatedAt).format('YYYY-MM-DD HH:mm')
                  :
                    'N/A'
                }
              }
            />
            <div className='Table__col'>
              <div className='Table__controls'>
                {canEdit('PostScoreParameter') &&
                  <EditParameterModal
                    title="Edit Post Score Parameter"
                    parameter={postScoreParameter}
                    updateEndpoint={`/${gon.currentProvider}/api/post_score_parameters/${postScoreParameter.id}`}
                  />
                }
              </div>
            </div>

          </div>

        ))}
      </div>
    </React.Fragment>
  )
}

export default PostScoreParametersList
